<div class="list-page">

  <div class="tools">
    <div class="but" *ngFor="let config of groupActions" (click)="act(config.action)">
      <mat-icon>{{config.icon}}</mat-icon>
      {{config.name}}
    </div>
  </div>
  <table>
    <thead>
    <tr>
      <th *ngFor="let cell of tableConfig.cells">
        <div class="table-header">
          {{ prepareHeader(cell.header) | titlecase }}

          <div class="header-tools">
            <div class="filter-preview" *ngIf="filters[cell.field]"><i>{{filterLabels[cell.field]?.slice(0, 12)}}{{filterLabels[cell.field]?.length > 12 ? '...' : ''}}</i></div>
            <mat-icon (click)="openFilter(cell.field)" *ngIf="cell.filterType !== EFilterType.NONE">filter_list</mat-icon>
            <mat-icon (click)="changeSort(cell.field)" *ngIf="cell.sortable">{{sortIcon(cell.field)}}</mat-icon>
          </div>
        </div>
      </th>
      <th *ngIf="tableConfig.actions.length"></th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let row of data.list" [class]="tableConfig.rowClass ? tableConfig.rowClass(row) : ''">
      <td *ngFor="let cell of tableConfig.cells">
        {{ prepareValue(row, cell) }}
      </td>
      <td *ngIf="tableConfig.actions.length" class="icons">
        <span *ngFor="let action of tableConfig.actions" class="icon" (click)="act(action, row)">
          <i>
            <mat-icon [fontIcon]="action"></mat-icon>
          </i>
        </span>
      </td>
    </tr>
    </tbody>

    <tfoot>
      <tr>
        <td [colSpan]="tableConfig.cells.length + (tableConfig.actions.length ? 1 : 0)">

          <div class="empty" *ngIf="!data.list.length">No Records</div>


          <div class="pagination" *ngIf="data.list.length">

            <div class="summary">
              <span class="summary-item">{{(data.page-1)*data.perPage + 1}}</span>
              <span class="summary-item">-</span>
              <span class="summary-item">{{ Math.min(data.page*data.perPage, data.total)}}</span>
              <span class="summary-item">из</span>
              <span class="summary-item">{{data.total}}</span>
            </div>


            <div class="pages">
              <div class="page" (click)="pickPage(1)" *ngIf="data.page > 2">1</div>
              <div class="dots" *ngIf="data.page > 3">...</div>
              <div class="page" (click)="pickPage(data.page - 1)" *ngIf="data.page > 1">{{data.page-1}}</div>
              <div class="page active" *ngIf="maxPage > 1">{{data.page}}</div>
              <div class="page" (click)="pickPage(data.page+1)" *ngIf="data.page < maxPage">{{data.page+1}}</div>
              <div class="dots" *ngIf="data.page + 2 < maxPage">...</div>
              <div class="page" (click)="pickPage(maxPage)" *ngIf="data.page + 1 < maxPage">{{maxPage}}</div>
            </div>

          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
